module.exports = __webpack_public_path__ + "img/lx.d1568629.png";